'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const ArrowSvgRight = require('dibs-vg/dist/react/arrow-right');
const ArrowSvgLeft = require('dibs-vg/dist/react/arrow-left');

const upperFirst = string => string.charAt(0).toUpperCase() + string.slice(1);

const Arrow = props => {
    const { onClick, direction, classNames } = props;

    const arrowWrapperClass = classNames[`arrowWrapper${upperFirst(direction)}`] || `arrow-carousel-arrow-wrapper-${direction}`;
    const arrowClass = classNames[`arrow${upperFirst(direction)}`] || `arrow-carousel-arrow-${direction}`;
    const ArrowDirection = direction === 'right' ? ArrowSvgRight : ArrowSvgLeft;

    return (
        <span className={arrowWrapperClass} onClick={onClick}>
            <ArrowDirection className={arrowClass} />
        </span>
    );
};

Arrow.propTypes = {
    onClick: PropTypes.func,
    direction: PropTypes.string,
    classNames: PropTypes.object
};

Arrow.defaultProps = {
    classNames: {}
};

const ArrowCarouselComponent = props => {
    const { showArrows, onLeftArrowClick, onRightArrowClick, createCarousel, classNames } = props;
    return (
        <div className={classNames.arrowCarouselWrapper || `arrow-carousel-wrapper`}>
            {showArrows ? <Arrow direction="left" onClick={onLeftArrowClick} classNames={classNames} /> : null}
            {createCarousel()}
            {showArrows ? <Arrow direction="right" onClick={onRightArrowClick} classNames={classNames} /> : null}
        </div>
    );
};

ArrowCarouselComponent.displayName = 'ArrowCarouselComponent';

ArrowCarouselComponent.propTypes = {
    createCarousel: PropTypes.func,
    onLeftArrowClick: PropTypes.func,
    onRightArrowClick: PropTypes.func,
    classNames: PropTypes.object,
    showArrows: PropTypes.bool
};

ArrowCarouselComponent.defaultProps = {
    classNames: {}
};


module.exports = ArrowCarouselComponent;



// WEBPACK FOOTER //
// ./assets/js/global/components/carousel/views/ArrowCarouselComponent.jsx